<template>
  <div class="token-consume bg--color-11">
    <div class="token-consume__wrapper bg--color-01">
      <div class="token-consume__container container-new">
        <div class="token-consume__info">
          <div class="token-consume__info-title">
            <span
              class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
            >
              {{ $t('tokenNew.consumeBlock.title') }}
            </span>

            <img
              :src="require('@/assets/img/token/arrow--mobile.svg')"
              class="token-consume__arrow-mobile"
            >
          </div>

          <span
            class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03"
          >
            {{ $t('tokenNew.consumeBlock.subtitle') }}
          </span>

          <img
            :src="require('@/assets/img/token/arrow.svg')"
            class="token-consume__arrow"
          >
        </div>

        <div class="token-consume__items">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="token-consume__item bg--color-02"
          >
            <img :src="item.icon" :alt="item.alt">

            <span
              class="txt txt--22px txt--height-30px txt--26px--m txt--height-34px--m txt--color-04 txt--bold"
            >
              {{ item.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenConsume',
  computed: {
    items () {
      return [
        {
          icon: require('@/assets/img/token/consume/fees.svg'),
          alt: 'coin icon',
        },
        {
          icon: require('@/assets/img/token/consume/trading-commision.svg'),
          alt: 'coin icon',
        },
        {
          icon: require('@/assets/img/token/consume/ticket.svg'),
          alt: 'ticker icon',
        },
        {
          icon: require('@/assets/img/token/consume/demo-tokens.svg'),
          alt: 'coins icon',
        },
        {
          icon: require('@/assets/img/token/consume/quiz.svg'),
          alt: 'answer icon',
        },
        {
          icon: require('@/assets/img/token/consume/ten.svg'),
          alt: 'percent icon',
        },
        {
          icon: require('@/assets/img/token/consume/access.svg'),
          alt: 'message icon',
        },
      ].map((item, index) => {
        item.text = this.$t(`tokenNew.consumeBlock.items.${index}`)
        return item
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.token-consume {
  $containerGap: 24px;

  &__wrapper {
    padding: toRem(20px) 0;
    background: color('color-01');
    border-radius: toRem(20px);
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    @include bp(l) {
      padding: toRem(60px) 0;
      border-radius: toRem(60px);
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem($containerGap);

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: toRem(10px);
    position: relative;

    @include bp(1100px) {
      gap: toRem(18px);
      padding-right: calc(162px - #{$containerGap});
    }
  }

  &__info-title {
    @include bp(0, m) {
      display: flex;
      align-items: center;
      gap: toRem(10px);
    }
  }

  &__arrow {
    display: none;
    position: absolute;
    right: 0;
    bottom: toRem(-100%);

    @include bp(m) {
      display: block;
    }
  }

  &__arrow-mobile {
    @include bp(m) {
      display: none;
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(16px);
  }

  &__item {
    display: grid;
    grid-template-columns: toRem(48px) 1fr;
    align-items: center;
    gap: toRem(12px);
    padding: toRem(18px);
    border-radius: toRem(20px);

    img {
      max-width: toRem(48px);

      @include bp(m) {
        max-width: toRem(70px);
      }
    }

    @include bp(m) {
      // padding: toRem(24px);
      grid-template-columns: toRem(70px) 1fr;
      gap: toRem(24px);
    }
  }
}
</style>
